import { CButton, CLabel, CRow } from '@coreui/react';
import * as React from 'react';
import { Table } from 'reactstrap';
import { IDiagnoseMessage, IPoolInfo } from '../abstraction/index';
import { AppLabels } from '../core/AppLabels';

interface IProps {
	rows: IPoolInfo[];
	onStartPoolClick: (poolId: string) => void;
	onStopPoolClick: (poolId: string) => void;
}


// Tableau contenant la liste des pools X3 disponibles
// 
export class KPoolList extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);

	}

	// Demande de démarrage d'un pool - transmet à l'appelant qui gère le process
	onStartPoolClik = (poolId: string) => {
		if (this.props.onStartPoolClick) this.props.onStartPoolClick(poolId);
	}

	// Demande d'arrêt d'un pool - transmet à l'appelant qui gère le process
	onStopPoolClik = (poolId: string) => {
		if (this.props.onStopPoolClick) this.props.onStopPoolClick(poolId);
	}

	//#region Rendu principal

	render() {

		return (
			<div className="  KPoolList KAdminBorder">
				<div className="KControl ">
					<CLabel >{AppLabels.x3PoolsTitle}</CLabel>
					<div className="KControlTable" >
						<Table size="sm" >
							<thead>
								<tr>
									<th className="KTableHeaderCol" >{AppLabels.alias}</th>

									<th className="KTableHeaderCol" >{AppLabels.autoStart}</th>
									<th className="KTableHeaderCol" >{AppLabels.manualStop}</th>

									<th className="KTableHeaderCol" >{AppLabels.maxSize}</th>
									<th className="KTableHeaderCol" >{AppLabels.initSize}</th>

									<th className="KTableHeaderCol" >{AppLabels.unusedTimeout}</th>
									<th className="KTableHeaderCol" >{AppLabels.lifeTimeout}</th>

									<th className="KTableHeaderCol" >{AppLabels.start}</th>
									<th className="KTableHeaderCol" >{AppLabels.stop}</th>

								</tr>
							</thead>
							<tbody>{
								this.props.rows.map((row, index) => {
									return (
										<tr key={index}>
											<td className="">{row.poolName}</td>

											<td className="">{row.autoStart == true ? AppLabels.Yes_short : AppLabels.No_short}</td>
											<td className="">{row.autoStartDisabled == true ? AppLabels.Yes_short : AppLabels.No_short}</td>

											<td className="">{row.maxSize}</td>
											<td className="">{row.initSize}</td>

											<td className="">{row.unusedTimeout}</td>
											<td className="">{row.lifeTimeout}</td>

											<td className=""><CButton onClick={() => { this.onStartPoolClik(row.poolId) }} size="sm" color="success">{AppLabels.start}</CButton></td>
											<td className=""><CButton onClick={() => { this.onStopPoolClik(row.poolId) }} size="sm" color="danger">{AppLabels.stop}</CButton></td>
										</tr>
									)
								}
								)
							}
							</tbody>
						</Table>
					</div>
				</div >
			</div>);
	}

	//#endregion
}
